module.exports = __webpack_public_path__ + "img/link2.86ceca8d.png";